// extracted by mini-css-extract-plugin
module.exports = {"color-white":"theme_color-white__1tavu","color-black":"theme_color-black__2Zvbw","color-default-gray":"theme_color-default-gray__2KrrS","default":"theme_default__mSJ9-"};